'use es6';

export const none = 'none';
export const triggerPress = 'trigger-press';
export const triggerHover = 'trigger-hover';
export const triggerFocus = 'trigger-focus';
export const outsidePress = 'outside-press';
export const itemPress = 'item-press';
export const closePress = 'close-press';
export const linkPress = 'link-press';
export const clearPress = 'clear-press';
export const chipRemovePress = 'chip-remove-press';
export const trackPress = 'track-press';
export const incrementPress = 'increment-press';
export const decrementPress = 'decrement-press';
export const inputChange = 'input-change';
export const inputClear = 'input-clear';
export const inputBlur = 'input-blur';
export const inputPaste = 'input-paste';
export const inputPress = 'input-press';
export const focusOut = 'focus-out';
export const escapeKey = 'escape-key';
export const closeWatcher = 'close-watcher';
export const listNavigation = 'list-navigation';
export const keyboard = 'keyboard';
export const pointer = 'pointer';
export const drag = 'drag';
export const wheel = 'wheel';
export const scrub = 'scrub';
export const cancelOpen = 'cancel-open';
export const siblingOpen = 'sibling-open';
export const disabled = 'disabled';
export const missing = 'missing';
export const initial = 'initial';
export const imperativeAction = 'imperative-action';
export const swipe = 'swipe';
export const windowResize = 'window-resize';